import { CheckCircleOutlined, LockOutlined, StopOutlined } from "@ant-design/icons";
import { Input, message, PageHeader, Popconfirm, Table, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, Form, FormItem, InputItem, ModalItem, SelectItem, SubHeaderItem, TagItem } from "../../../Components/Items";
import { colorPaleta } from "../../../Components/TagItem";

const estiloTooltip = { fontSize: "10px", padding: "1px 5px", minHeight: "auto" };

class UsuariosBiwo extends Component {
    formPassword = React.createRef();
    state = {
        loading: false,
        usuarios: [],
        totalRecords: 0,
        conteos: null,
        page: 1,
        pageSize: 50,
        filtros: { texto: "", masterId: undefined, empresaId: undefined, rolBiwo: undefined, departamento: undefined, estado: undefined },
        masters: [],
        roles: [],
        departamentos: [],
        usuarioPassword: null,
    };

    componentDidMount() {
        axios.post("cobroBiwo/selectMastersCobro", {}, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) this.setState({ masters: res.data.data });
        });
        axios.post("usuariosBiwo/selectCatalogosUsuarios", {}, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) this.setState({ roles: res.data.roles, departamentos: res.data.departamentos });
        });
        this.consultar();
    }

    consultar = () => {
        this.setState({ loading: true });
        const { page, pageSize, filtros } = this.state;
        axios
            .post("usuariosBiwo/selectUsuariosBiwo", { ...filtros, page, pageSize }, { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) this.setState({ loading: false, usuarios: res.data.data, totalRecords: res.data.totalRecords, conteos: res.data.conteos });
                else {
                    this.setState({ loading: false });
                    message.error(res.data.message || "Error al consultar los usuarios");
                }
            })
            .catch(() => this.setState({ loading: false }));
    };

    filtrar = (cambios) => this.setState((s) => ({ filtros: { ...s.filtros, ...cambios }, page: 1 }), this.consultar);

    accion = (ruta, body) => {
        this.setState({ loading: true });
        return axios.post("usuariosBiwo/" + ruta, body, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) {
                message.success(res.data.message);
                this.consultar();
                return true;
            }
            this.setState({ loading: false });
            message.error(res.data.message || "No se pudo guardar");
            return false;
        });
    };

    guardarPassword = () => {
        this.formPassword.current.validateFields().then((values) => {
            if (values.password !== values.confirmar) return message.error("Las contraseñas no coinciden");
            this.accion("cambiarPasswordUsuarioBiwo", { usuarioId: this.state.usuarioPassword._id, password: values.password }).then((ok) => {
                if (ok) this.setState({ usuarioPassword: null });
            });
        });
    };

    renderConteos() {
        const c = this.state.conteos;
        if (!c) return null;
        const { rolBiwo, estado } = this.state.filtros;
        const tarjetas = [
            { titulo: "Usuarios", valor: c.total, color: colorPaleta("cyan"), activo: !rolBiwo && !estado, filtro: { rolBiwo: undefined, estado: undefined } },
            { titulo: "Contadores externos", valor: c.contadorExterno, color: colorPaleta("azul"), activo: rolBiwo === "contadorExterno", filtro: { rolBiwo: "contadorExterno" } },
            { titulo: "Soporte BIWO", valor: c.soporteBiwo, color: colorPaleta("lila"), activo: rolBiwo === "soporteBiwo", filtro: { rolBiwo: "soporteBiwo" } },
            { titulo: "Sin rol (se cobran)", valor: c.sinRol, color: colorPaleta("ambar"), activo: rolBiwo === "sinRol", filtro: { rolBiwo: "sinRol" } },
            { titulo: "Activos", valor: c.activos, color: colorPaleta("verdeNatural"), activo: estado === 1, filtro: { estado: 1 } },
            { titulo: "Deshabilitados", valor: c.deshabilitados, color: colorPaleta("danger"), activo: estado === 2, filtro: { estado: 2 } },
        ];
        return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
                {tarjetas.map((t) => (
                    <div
                        key={t.titulo}
                        onClick={() => this.filtrar(t.filtro)}
                        style={{
                            cursor: "pointer",
                            flex: "1 1 150px",
                            minWidth: 150,
                            padding: "8px 14px",
                            borderRadius: 8,
                            border: `1px solid ${t.activo ? t.color : "#f0f0f0"}`,
                            borderLeft: `4px solid ${t.color}`,
                            background: t.activo ? `${t.color}12` : "white",
                            boxShadow: t.activo ? `0 0 0 1px ${t.color}` : "none",
                            transition: "all 0.2s",
                        }}
                    >
                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>{t.titulo}</div>
                        <div style={{ fontSize: 20, fontWeight: 600, color: "#262626" }}>{t.valor}</div>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const nombreDepartamento = new Map(this.state.departamentos.map((d) => [d.clave, d.nombre]));
        const opcionesRol = [{ value: "", label: "Sin rol (se cobra)" }, ...this.state.roles.map((r) => ({ value: r.clave, label: r.nombre }))];

        return (
            <>
                <PageHeader
                    title="Usuarios BIWO"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 0, borderRadius: "6px 6px 0 0" }}
                />
                <SubHeaderItem>
                    <Input.Search placeholder="Buscar nombre, usuario, correo o corporativo" allowClear style={{ width: 320, maxWidth: "100%" }} onSearch={(texto) => this.filtrar({ texto })} />
                    <SelectItem
                        width={260}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        placeholder="Master"
                        value={this.state.filtros.masterId}
                        onChange={(masterId) => this.filtrar({ masterId, empresaId: undefined })}
                        options={this.state.masters.map((m) => ({ value: m._id, label: m.nombreCorporativo ? `${m.nombre} - ${m.nombreCorporativo}` : m.nombre }))}
                    />
                    <SelectItem
                        width={260}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        placeholder="Empresa"
                        value={this.state.filtros.empresaId}
                        onChange={(empresaId) => this.filtrar({ empresaId })}
                        options={this.state.masters
                            .filter((m) => !this.state.filtros.masterId || m._id === this.state.filtros.masterId)
                            .flatMap((m) => m.empresas.map((e) => ({ value: e._id, label: this.state.filtros.masterId ? e.nombre : `${e.nombre} (${m.nombre})` })))}
                    />
                    <SelectItem
                        width={180}
                        allowClear
                        placeholder="Rol"
                        value={this.state.filtros.rolBiwo}
                        onChange={(rolBiwo) => this.filtrar({ rolBiwo })}
                        options={[{ value: "sinRol", label: "Sin rol" }, ...this.state.roles.map((r) => ({ value: r.clave, label: r.nombre }))]}
                    />
                    <SelectItem
                        width={200}
                        allowClear
                        placeholder="Departamento"
                        value={this.state.filtros.departamento}
                        onChange={(departamento) => this.filtrar({ departamento })}
                        options={this.state.departamentos.map((d) => ({ value: d.clave, label: d.nombre }))}
                    />
                    <SelectItem
                        width={150}
                        allowClear
                        placeholder="Estado"
                        value={this.state.filtros.estado}
                        onChange={(estado) => this.filtrar({ estado })}
                        options={[{ value: 1, label: "Activos" }, { value: 2, label: "Deshabilitados" }]}
                    />
                </SubHeaderItem>
                <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                {this.renderConteos()}
                <Table
                    size="small"
                    className="custom-small-table"
                    scroll={{ x: "max-content" }}
                    rowKey="_id"
                    loading={this.state.loading}
                    dataSource={this.state.usuarios}
                    pagination={{
                        current: this.state.page,
                        pageSize: this.state.pageSize,
                        total: this.state.totalRecords,
                        showSizeChanger: true,
                        onChange: (page, pageSize) => this.setState({ page, pageSize }, this.consultar),
                    }}
                    columns={[
                        {
                            title: "Usuario",
                            render: (u) => (
                                <>
                                    <div style={{ fontWeight: 600 }}>
                                        {u.nombre} {u.master && <TagItem morado style={{ marginLeft: 4 }}>Master</TagItem>}
                                    </div>
                                    <div style={{ fontSize: 12, color: "#8c8c8c" }}>{u.nombreUsuario}{u.correo ? ` · ${u.correo}` : ""}</div>
                                </>
                            ),
                        },
                        { title: "Master", dataIndex: "masterNombre" },
                        { title: "Empresas", dataIndex: "empresas", render: (v) => (v || []).join(", ") },
                        { title: "Departamentos", dataIndex: "departamentos", render: (v) => (v || []).map((d) => <TagItem key={d} gris>{nombreDepartamento.get(d) || d}</TagItem>) },
                        {
                            title: "Rol BIWO",
                            width: 200,
                            render: (u) =>
                                u.master ? (
                                    "—"
                                ) : (
                                    <SelectItem
                                        width="100%"
                                        sinBorde
                                        value={u.rolBiwo || ""}
                                        options={opcionesRol}
                                        onChange={(rolBiwo) => this.accion("asignarRolBiwo", { usuarioId: u._id, rolBiwo: rolBiwo || null })}
                                    />
                                ),
                        },
                        {
                            title: "Estado",
                            dataIndex: "estado",
                            width: 120,
                            render: (v) => (v === 1 ? <TagItem verdeNatural>Activo</TagItem> : <TagItem danger>Deshabilitado</TagItem>),
                        },
                        {
                            title: "Acciones",
                            key: "acciones",
                            width: 100,
                            align: "center",
                            render: (u) => (
                                <div className="acciones-container">
                                    {!u.master && (
                                        <Popconfirm
                                            title={u.estado === 1 ? "¿Deshabilitar este usuario? No podrá iniciar sesión" : "¿Habilitar este usuario?"}
                                            onConfirm={() => this.accion("cambiarEstadoUsuarioBiwo", { usuarioId: u._id, estado: u.estado === 1 ? 2 : 1 })}
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <Tooltip title={u.estado === 1 ? "Deshabilitar" : "Habilitar"} overlayInnerStyle={estiloTooltip}>
                                                <ButtonItem size="small" {...(u.estado === 1 ? { rojo: true } : { verdeNatural: true })} icon={u.estado === 1 ? <StopOutlined /> : <CheckCircleOutlined />} />
                                            </Tooltip>
                                        </Popconfirm>
                                    )}
                                    <Tooltip title="Cambiar contraseña" overlayInnerStyle={estiloTooltip}>
                                        <ButtonItem size="small" naranja icon={<LockOutlined />} onClick={() => this.setState({ usuarioPassword: u })} />
                                    </Tooltip>
                                </div>
                            ),
                        },
                    ]}
                />
                </div>
                <ModalItem
                    visible={!!this.state.usuarioPassword}
                    title={this.state.usuarioPassword ? `Cambiar contraseña de ${this.state.usuarioPassword.nombre}` : ""}
                    onCancel={() => this.setState({ usuarioPassword: null })}
                    footer={null}
                    destroyOnClose
                    spinning={false}
                    width={500}
                >
                    <Form
                        ref={this.formPassword}
                        layout
                        bottom={
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                                <ButtonItem danger onClick={() => this.setState({ usuarioPassword: null })}>Cancelar</ButtonItem>
                                <ButtonItem naranja onClick={this.guardarPassword}>Guardar</ButtonItem>
                            </div>
                        }
                    >
                        <FormItem label="Contraseña" name="password" required min={5} margin>
                            <InputItem type="password" />
                        </FormItem>
                        <FormItem label="Confirmar" name="confirmar" required margin>
                            <InputItem type="password" />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(UsuariosBiwo);
